
<disco-data (context)="contextChanged($event)" [appId]="appId" [tabId]="'tasks'" [requestId]="defaultRequestId"
    [filters]="filters" [start]="1" [size]="20" [sorts]="sorts">
    <ng-template let-context #myTemplate>
        <div *ngIf="context" id="standard-table">
            <div class="main-div">
                <kendo-grid [data]="filteredData" [pageSize]="20" [loading]="isLoading"
                    (pageChange)="context.pageChange($event.skip, $event.take)" [sort]="sort"
                    (sortChange)="sortChange($event)" [sortable]="{allowUnsort: true}" [navigable]="true"
                    [resizable]="true" [reorderable]="true">
                    <div *ngFor="let column of columns;">
                        <kendo-grid-column [field]="column.fieldName" [format]="column.format" [title]="column.display"
                            [width]="column.width">
                            <ng-template *ngIf="column.fieldName=='Subject'" kendoGridCellTemplate let-dataItem
                                let-rowIndex="rowIndex">
                                <span class="hyperlink" (click)="navigateToTask(dataItem)">
                                    {{dataItem[column.fieldName]}}</span>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                                <span> {{ fs.getValue(dataItem[column.fieldName] , column.dataType)}}</span>
                            </ng-template>
                        </kendo-grid-column>
                    </div>
                </kendo-grid>
            </div>
        </div>
    </ng-template>
</disco-data>